import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import { useEffect } from "react";
import ProgressButtons from "../ProgressButtons";
import relationshipList from "../../../data/relationshipList";

// 1
// emergencyContact1Name
// emergencyContact1Phone
// emergencyContact1Relationship - Select List
// authorizedForPickup1 - Yes/No
// 2
// emergencyContact2Name
// emergencyContact2Phone
// emergencyContact2Relationship - Select List
// authorizedForPickup2 - Yes/No

const R16EmergencyContacts = ({ validateFormData, submitted }) => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,

    formData: {
      emergencyContact1FirstName,
      emergencyContact1LastName,
      emergencyContact1Phone,
      emergencyContact1Relationship,
      authorizedForPickup1,
      emergencyContact2FirstName,
      emergencyContact2LastName,
      emergencyContact2Phone,
      emergencyContact2Relationship,
      authorizedForPickup2,
    },
    onFormDataChange,
    pass: { emergencyContacts },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const formatPhoneNumber = (evt) => {
    const regex = /^\+?[0-9-]+$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      var aVal = evt.target.value;
      aVal = aVal
        .replace(/\\D/g, "")
        .replace(/ /g, "")
        .replace(/\-/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "");
      if (aVal.length >= 10 && aVal.charAt(0) == "1")
        aVal = aVal.replace("-", "").replace("-", "");
      if (aVal.length > 0) {
        if (aVal.length > 8) {
          aVal =
            aVal.substring(0, 3) +
            "-" +
            aVal.substring(3, 6) +
            "-" +
            aVal.substring(6, 10);
          // window.alert(aVal);
          evt.target.value = aVal;
        } else if (aVal.length == 7) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 7);
          evt.target.value = aVal;
        }
      }
      onFormDataChange(evt);
    }
  };

  const isEmergencyContactValid =
    emergencyContact1FirstName !== "" &&
    emergencyContact1LastName !== "" &&
    emergencyContact1Phone !== "" &&
    emergencyContact1Relationship !== "" &&
    authorizedForPickup1 !== "" &&
    emergencyContact2FirstName !== "" &&
    emergencyContact2LastName !== "" &&
    emergencyContact2Phone !== "" &&
    emergencyContact2Relationship !== "" &&
    authorizedForPickup2 !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Emergency Contacts <span>(15/15)</span>
          <hr />
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 1 First Name </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact1FirstName"
            onChange={(e) => handleChange(e)}
            value={emergencyContact1FirstName}
            style={{
              border:
                submitted && emergencyContact1FirstName === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />
        </div>
        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 1 Last Name </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact1LastName"
            onChange={(e) => handleChange(e)}
            value={emergencyContact1LastName}
            style={{
              border:
                submitted && emergencyContact1LastName === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 1 Phone Number</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            placeholder="XXX-XXX-XXXX"
            name="emergencyContact1Phone"
            onChange={(e) => formatPhoneNumber(e)}
            value={emergencyContact1Phone}
            style={{
              border:
                submitted && emergencyContact1Phone === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />

          {emergencyContact1Phone !== "" &&
            !validatePhone(emergencyContact1Phone) && (
              <p className="validEmail">
                Please provide a valid phone number in the following format
                XXX-XXX-XXXX
              </p>
            )}
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 1 Relationship </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="emergencyContact1Relationship"
            value={emergencyContact1Relationship}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                submitted && emergencyContact1Relationship === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          >
            <option value="">Please Select </option>
            {relationshipList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Authorized for Pickup </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                submitted && authorizedForPickup1 === ""
                  ? "2px solid #d8302f"
                  : "",
           }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={authorizedForPickup1["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup1"
                style={{
                  border:
                    submitted && authorizedForPickup1 === ""
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={authorizedForPickup1["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup1"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 2 First Name </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact2FirstName"
            onChange={(e) => handleChange(e)}
            value={emergencyContact2FirstName}
            style={{
              border:
                submitted && emergencyContact2FirstName === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 2 Last Name </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact2LastName"
            onChange={(e) => handleChange(e)}
            value={emergencyContact2LastName}
            style={{
              border:
                submitted && emergencyContact2LastName === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 2 Phone Number</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            placeholder="XXX-XXX-XXXX"
            name="emergencyContact2Phone"
            onChange={(e) => formatPhoneNumber(e)}
            value={emergencyContact2Phone}
            style={{
              border:
                submitted && emergencyContact2Phone === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          />
          {emergencyContact2Phone !== "" &&
            !validatePhone(emergencyContact2Phone) && (
              <p className="validEmail">
                Please provide a valid phone number in the following format
                XXX-XXX-XXXX
              </p>
            )}
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Emergency Contact 2 Relationship </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="emergencyContact2Relationship"
            value={emergencyContact2Relationship}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                submitted && emergencyContact2Relationship === ""
                  ? "2px solid #d8302f"
                  : "1px solid #ccc",
            }}
          >
            <option value="">Please Select </option>
            {relationshipList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>Authorized for Pickup</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                submitted && authorizedForPickup2 === ""
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={authorizedForPickup2["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup2"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={authorizedForPickup2["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup2"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="group">{subFormLevels.emergencyContacts === 0}</div>
      </div>
      <ProgressButtons
        validation={isEmergencyContactValid}
        name="emergencyContacts"
      />
    </>
  );
};

export default R16EmergencyContacts;
